import { BackofficeBusinessDataController } from './backoffice-business-data.controller'

function backofficeBusinessDataDirective () {
  return {
    restrict: 'E',
    templateUrl: '/admin/directives/backoffice-business-data/backoffice-business-data-directive.html?$$REVISION$$',
    controller: BackofficeBusinessDataController
  }
}

export { backofficeBusinessDataDirective }
